<template>
  <div id="app-layout">
    <div class="bg-sand">
      <div class="inner-container">
        <app-header-checkout />
      </div>
    </div>
    <div class="bg-white py-4">
      <div class="inner-container-narrow pt-4 pb-8">
        <component
          v-if="type"
          :is="`checkout-${type}`"
        />
      </div>
    </div>
    <app-footer />
  </div>
</template>

<script>
import AppFooter from "../components/site/AppFooter"
import AppHeaderCheckout from "../components/site/AppHeaderCheckout"
import CheckoutPurchase from "./checkout/Purchase"
import CheckoutPurchaseVic from "./checkout/PurchaseVic"
import CheckoutRenew from "./checkout/Renew"
export default {
  name: "Checkout",
  components: {
    CheckoutRenew,
    CheckoutPurchaseVic,
    CheckoutPurchase,
    AppHeaderCheckout,
    AppFooter,
  },
  data: () => ({
    type: null,
  }),
  created() {
    window.scrollTo(0, 0)
  },
  mounted() {
    let type = this.$store.getters["account/user_access"].hasPurchasedWill
      ? "renew"
      : "purchase"
    if (
      type === "purchase" &&
      (this.$store.getters["account/user_address"].value.state === "vic" ||
        this.$store.getters["account/user_address"].value.state === "nsw")
    ) {
      type = type + "-vic"
    }

    this.type = type
  },
}
</script>

<style lang="scss"></style>
